import React from "react";
import PoemsList from "../../components/PoemsList/PoemsList";

const PoemsListPage = () => {
  return (
    <div>
      <PoemsList />
    </div>
  );
};

export default PoemsListPage;
